"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveProjectFile = exports.sharingReturnPath = exports.clearProjectShareToken = exports.getProjectShareToken = exports.captureProjectShareToken = void 0;
const key = (projectId) => `project-share:${projectId}`;
function captureProjectShareToken() {
    const match = window.location.pathname.match(/^\/projects\/(\d+)$/);
    const token = new URLSearchParams(window.location.hash.slice(1)).get('share');
    if (match && token && /^[a-f0-9]{64}$/.test(token)) {
        sessionStorage.setItem(key(Number(match[1])), token);
        window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}`);
    }
}
exports.captureProjectShareToken = captureProjectShareToken;
function getProjectShareToken(projectId) {
    var _a;
    captureProjectShareToken();
    return projectId ? (_a = sessionStorage.getItem(key(projectId))) !== null && _a !== void 0 ? _a : undefined : undefined;
}
exports.getProjectShareToken = getProjectShareToken;
function clearProjectShareToken(projectId) {
    sessionStorage.removeItem(key(projectId));
}
exports.clearProjectShareToken = clearProjectShareToken;
function sharingReturnPath() {
    const path = sessionStorage.getItem('project-share-return');
    return path && /^\/projects\/\d+$/.test(path) ? path : undefined;
}
exports.sharingReturnPath = sharingReturnPath;
function saveProjectFile(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
exports.saveProjectFile = saveProjectFile;
